import React from 'react';
export function Header() {
  return <header className="w-full border-b border-slate-200 bg-white sticky top-0 z-50" data-id="element-158">
      <div className="max-w-4xl mx-auto px-4 h-14 flex items-center justify-between text-xs md:text-sm font-bold tracking-wider text-slate-500 uppercase" data-id="element-159">
        <div className="flex items-center gap-2 md:gap-4" data-id="element-160">
          <span className="text-orange-600" data-id="element-161">Advertorial</span>
          <span className="hidden md:inline text-slate-300" data-id="element-162">•</span>
          <span className="text-slate-900" data-id="element-163">FlossFocus.com</span>
          <span className="hidden md:inline text-slate-300" data-id="element-164">•</span>
          <span className="hidden sm:inline" data-id="element-165">Health & Wellness</span>
        </div>
        <div className="hidden md:block text-slate-400 font-normal normal-case" data-id="element-166">
          Sponsored Content
        </div>
      </div>
    </header>;
}